import React from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import Icon, {
    type SVGPropsOptionalViewBox,
} from '@splunk/react-icons/SVGEnterprise';

/* eslint-disable max-len */
export default function ShareDashboard(props: SVGPropsOptionalViewBox) {
    return (
        <Icon screenReaderText={_('Share')} viewBox="0 0 32 32" {...props}>
            <path
                fill="currentColor"
                d="M14 9V5L21 12L14 19V14.9C9 14.9 5.5 16.5 3 20C4 15 7 10 14 9Z"
            />
        </Icon>
    );
}
